import { Content } from 'store/landing/types';
import React, { FC } from 'react';
import cn from 'classnames';
import { useLandingPageContext } from 'context/LandingPageContext';
import styles from './SeriesSteps.module.scss';

export interface SeriesStepsProps {
  contentItem: Content;
}

const SeriesSteps: FC<SeriesStepsProps> = ({ contentItem }: SeriesStepsProps) => {
  const { theme } = useLandingPageContext();
  const { steps } = contentItem;
  const { title, description, items } = steps || {};

  if (items && items.length === 0) {
    return (
      <div className={cn(styles.stepsContainer, styles[`theme-${theme}`])}>
        <h2 className={styles.title} dangerouslySetInnerHTML={{ __html: title || '' }} />
        {description && <h1 className={styles.description} dangerouslySetInnerHTML={{ __html: description || '' }} />}
      </div>
    );
  }
  return (
    <div className={styles.container}>
      {title && <h2 className={styles.title} dangerouslySetInnerHTML={{ __html: title || '' }} />}
      {description && <h1 className={styles.description} dangerouslySetInnerHTML={{ __html: description || '' }} />}
      <div className={styles.stepsContainer}>
        <div className={styles.steps}>
          {items?.map((step, index) => (
            <div className={styles.step} key={`${step.title} + ${step.entryId}`}>
              <img src={step.imageUrl} alt={step.title} />
              <div className={styles.stepNumber}>{index + 1}.</div>
              <div className={styles.stepLabel} dangerouslySetInnerHTML={{ __html: step.title }} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SeriesSteps;
